import { useContext, useEffect } from 'react';
import { formatISO } from 'date-fns';
import useSWR from 'swr';

import { mapToProgram } from '../../forces/channels/mappers';
import { getRequestWithAccessToken } from '../../forces/utils/request';
import { useAuthToken } from '../../hooks/useAuthToken';
import { captureExceptionInSentry } from '../../utils/errorTracker/tracking';

import { TvGuideContext } from './TvGuideContext';

export const usePrograms = ({ epgUrl, shouldFetch }: { epgUrl: string; shouldFetch: boolean }) => {
  const accessToken = useAuthToken();

  const { selectedDate } = useContext(TvGuideContext);
  const url = `${epgUrl}/${formatISO(selectedDate, { representation: 'date' })}`;

  const { data: programs, error } = useSWR(
    shouldFetch ? url : null,
    async url => {
      const res = await getRequestWithAccessToken<RiksTV.ClientAPI.TitleWithCard[]>(accessToken)(url);
      return res.map(mapToProgram);
    },
    {
      // refresh on focus change if more than 5 minutes on idle
      focusThrottleInterval: 300_000,
    }
  );

  useEffect(() => {
    if (error) {
      captureExceptionInSentry(error);
    }
  }, [error]);

  return { programs };
};
